import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailEnvelope = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 25,
	viewBox: "0 0 33 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 30.3077,
		height: 22.2308,
		rx: 1,
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M30.6922 1.61523L16.1537 10.7018L1.61523 1.61523",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
export default SvgMailEnvelope;
